"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var json_api_fetch_1 = require("./json_api_fetch");
/**
 * @param commentQuery [CommentsFetchQuery] available queries:
 *                    - wallId [number] id of the wall
 */
function fetchComments(commentQuery) {
  var _a;
  var query = {
    wall_id: ((_a = commentQuery.wallId) === null || _a === void 0 ? void 0 : _a.toString()) || ''
  };
  if (commentQuery.pageStart) {
    query.page_start = commentQuery.pageStart;
  }
  return (0, json_api_fetch_1.jsonApiFetch)('comments', {
    query: query
  });
}
exports.default = fetchComments;